import * as React from 'react';
import { CallToActionContainer } from '../CallToAction/CallToActionContainer.js';
import { SecondaryActionContainer } from '../CallToAction/SecondaryActionContainer.js';
import { ExpanderToggleContainer } from '../ExpanderToggle/ExpanderToggleContainer.js';

const TopBar = ({ children  })=>/*#__PURE__*/ React.createElement("div", {
        className: "configurator-footer-topbar"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "configurator-footer-topbar__content"
    }, children), /*#__PURE__*/ React.createElement("div", {
        className: "configurator-footer-topbar__controls"
    }, /*#__PURE__*/ React.createElement(ExpanderToggleContainer, null), /*#__PURE__*/ React.createElement(SecondaryActionContainer, null), /*#__PURE__*/ React.createElement(CallToActionContainer, null)))
;

export { TopBar };
//# sourceMappingURL=TopBar.js.map
